
<!-- Header -->
<div class="row">
  <div class="col-12 dashboard-panel-header-flex-container">
    <span class="h6 lightgray-font">{{ title | translate}}</span>
    <div>
      <button class="btn btn-light dashboard-panel-button" (click)="onForceRefresh()" title="{{'i18n.domain.home.dashboard.shared.refresh-widget-data' | translate}}">
        <span class="icon-reset"></span>
      </button>
      @if (mode === WidgetMode.Edit || mode === WidgetMode.Preview) {
        <button class="btn btn-light dashboard-panel-button" (click)="onConfigure()">
          <span class="icon-settings"></span>
        </button>
      }
      @if (mode === WidgetMode.Edit) {
        <button class="btn btn-light dashboard-panel-button" (click)="onDelete()">
          <span class="icon-trash-can" style="color:red"></span>
        </button>
      }
    </div>
  </div>
</div>
<!-- Content -->
<div class="row">
  <div class="col-12">
    <ejs-grid #grid
              rowHeight="38"
              class="grid grid-filter"
              [dataSource]="data"
              [allowSorting]="true"
              [allowPaging]="true"
              [pageSettings]='pageSettings'
              [allowFiltering]="false"
              [filterSettings]="filterSettings"
              [allowGrouping]='true'
              [groupSettings]='groupOptions'
              (actionBegin)="actionBegin($event)"
              (actionComplete)="actionComplete($event)">
      <e-columns class="small-font">
        <e-column field="id" [visible]="false" [isPrimaryKey]="true"></e-column>
        <e-column field="{{ZONE_NAME_COLUMN_NAME}}"
                  uid="dcw-zone-name-{{panelId}}"
                  headerText="{{'i18n.domain.device-interaction.grid.zone' | translate}}"
                  clipMode="EllipsisWithTooltip"
                  type="string">
        </e-column>
        <e-column field="name"
                  uid="dcw-name-{{panelId}}"
                  headerText="{{'i18n.domain.device-interaction.grid.device' | translate}}"
                  clipMode="EllipsisWithTooltip"
                  type="string">
        </e-column>
        <e-column field="deviceType"
                  uid="dcw-deviceType-{{panelId}}"
                  headerText="{{'i18n.domain.device-interaction.grid.device-type' | translate}}"
                  clipMode="EllipsisWithTooltip"
                  type="string"
                  [filter]="typeFilter">
          <ng-template #filterItemTemplate let-data>{{formatType(data)}}</ng-template>
          <ng-template #template let-data>
            {{getDeviceType(data.deviceType) | translate}}
          </ng-template>
        </e-column>
        <e-column field="state"
                  uid="dcw-state-{{panelId}}"
                  headerText="{{'i18n.domain.device-interaction.grid.state' | translate}}"
                  clipMode="EllipsisWithTooltip"
                  type="string"
                  [filter]="stateFilter">
          <ng-template #filterItemTemplate let-data>{{formatState(data)}}</ng-template>
          <ng-template #template let-data>
            {{getDeviceState(data.state) | translate}}
          </ng-template>
        </e-column>
        <e-column field="currentDevicePosition"
                  uid="dcw-currentDevicePosition-{{panelId}}"
                  headerText="{{'i18n.domain.device-interaction.grid.position' | translate}}"
                  clipMode="EllipsisWithTooltip"
                  type="string">
        </e-column>
        <e-column field="interaction"
                  uid="dcw-interaction-{{panelId}}"
                  headerText="{{'i18n.domain.device-interaction.grid.interactions' | translate}}"
                  type="string"
                  autoFit="true"
                  width="25%"
                  [allowFiltering]="false"
                  [allowSorting]="false">
          <ng-template #template let-data>
            <div class="interaction-buttons-container">
              @for (command of data.supportedCommands; track command) {
                <ejs-tooltip [content]="command.commandDescription">
                  <button class="btn btn-sm btn-primary me-1 my-auto" (click)="executeDeviceCommand(data.id, command, data.currentDevicePosition)">
                    {{command.command}}
                  </button>
                </ejs-tooltip>
              }

              @if (data.currentDevicePosition === 'Pending') {
                <div class="spinner-wrapper d-flex align-items-center justify-content-center">
                  <div class="spinner-border spinner text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>
              }
            </div>
          </ng-template>
        </e-column>

      </e-columns>
    </ejs-grid>
  </div>
</div>

<ejs-dialog #widgetSettingsDialog
            class="dialog-min-height"
            [isModal]="true"
            [showCloseIcon]="true"
            (close)="onCloseSettingsDialog()"
            [visible]="false">
  <ng-template #header>
    {{'i18n.domain.home.dashboard.edit-settings-dialog-title' | translate}}
  </ng-template>
  <ng-template #content>
    @if (widgetSettingsDialog.visible) {
      <form id="userDeviceControlWidgetSettingsForm" [formGroup]="editSettingsForm" autocomplete="off">
        <div class="row">
          <div class="form-group col-12">
            <label class="control-label">{{'i18n.domain.home.dashboard.shared.widgets.title' | translate}}</label>
            <input id="title" name="title" type="text" autocomplete="off" class="form-control" formControlName="title" />
          </div>
        </div>
      </form>
    }
  </ng-template>
  <ng-template #footerTemplate>
    <button class="btn btn-primary"
            (click)="saveParameters()">
      {{'i18n.shared.ok' | translate}}
    </button>
  </ng-template>
</ejs-dialog>
